export default function final(x, y) {
  this.p1.x = x;
  this.p1.y = y;
}
